import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import styled from "styled-components";

import { Wrapper, Input, ErrorArea, ErrorMessage } from "components/TextForm";
import color from "constants/color";

// パーツ定義
const CalendarIcon = styled(FontAwesomeIcon)`
  position: absolute;
  color: ${color.text.gray};
  top: 15px;
  right: 15px;
  pointer-events: none;
`;
const DateInput = styled(Input)`
  &::-webkit-calendar-picker-indicator {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: auto;
    height: auto;
    color: transparent;
    background: transparent;
    z-index: 2;
    cursor: pointer;
  }
`;

// 本体
const DateForm = ({
  value = "",
  minDate = "",
  width = "200px",
  placeholder = "",
  required = false,
  readOnly = false,
  onChange = () => null,
  onBlur = () => null,
  onFocus = () => null,
  isError = false,
  errorMessage = "",
  errorDetectableBeforeBlur = false,
}: {
  value?: string;
  minDate?: string;
  width?: string;
  placeholder?: string;
  required?: boolean;
  readOnly?: boolean;
  pattern?: RegExp;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  isError?: boolean;
  errorMessage?: string;
  errorDetectableBeforeBlur?: boolean;
}) => {
  // 一部の場合（例：利用終了日）ではフォーカス前に既にエラー検出が必要。
  const [isErrorDetectable, setIsErrorDetectable] = useState(errorDetectableBeforeBlur);
  // フォーカスが外れたらエラーを検出可能にする
  const onBlurForm = () => {
    setIsErrorDetectable(true);
    onBlur();
  };

  return (
    <Wrapper>
      <DateInput
        type="date"
        min={minDate}
        width={width}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlurForm}
        required={required}
        readOnly={readOnly}
        isErrorDisplay={isError && isErrorDetectable}
      />
      <CalendarIcon icon={faCalendar} />
      <ErrorArea isErrorDisplay={isError && isErrorDetectable}>
        <ErrorMessage>{errorMessage}</ErrorMessage>
      </ErrorArea>
    </Wrapper>
  );
};

export default DateForm;
